import React, { useEffect } from "react";
import { useSdkContext } from "~/components/contexts";
import { useIsFirstTimeVisitDashboardWidget } from "~/components/dashboard-widget/hooks";
import { useControlledPromise } from "~/lib/utils";
import { Flag } from "./styles";
export const useHintTooltipRender = () => {
  const {
    hasAcceptedGDPR
  } = useSdkContext();
  const {
    isFirstTime,
    setIsFirstTime
  } = useIsFirstTimeVisitDashboardWidget();
  const {
    promise,
    reject,
    resolve
  } = useControlledPromise();
  useEffect(() => {
    if (hasAcceptedGDPR && isFirstTime) {
      return resolve.current({
        node: /*#__PURE__*/React.createElement(React.Fragment, null, "Find your recently read stories and latest notifications here.", /*#__PURE__*/React.createElement(Flag, null, "New")),
        onChangeUrl: () => {
          setIsFirstTime(false);
        },
        onClose: () => {
          setIsFirstTime(false);
        }
      });
    }
    return reject.current();
  }, [resolve, reject, isFirstTime, promise, setIsFirstTime, hasAcceptedGDPR]);
  return {
    hintTooltipRender: promise
  };
};